<template>
  <section class="operator-assistance workspace-stack">
    <article class="glass-surface workspace-panel">
      <div class="workspace-panel__header operator-assistance__header">
        <div>
          <span class="workspace-kicker"><i class="fas fa-keyboard"></i> Validación manual</span>
          <h2 class="operator-assistance__title">Buscar y confirmar acceso</h2>
          <p class="workspace-copy">Encuentra entradas por nombre, correo o código. Toca una fila para registrar el ingreso manual.</p>
        </div>
      </div>

      <form class="operator-assistance__toolbar" @submit.prevent="searchEvents()">
        <label class="workspace-search operator-assistance__search">
          <i class="fas fa-search"></i>
          <input v-model.trim="search" type="text" placeholder="Nombre, apellido, correo o código" />
        </label>
        <button class="workspace-button workspace-button--primary" type="submit">
          <i class="fas fa-magnifying-glass"></i>
          <span>Buscar</span>
        </button>
      </form>

      <div v-if="loadingMain || loadingList" class="operator-assistance__loading">
        <spring-spinner :size="56" color="#8cf3e8" />
        <p>{{ loadingMain ? 'Procesando acceso...' : 'Cargando entradas...' }}</p>
      </div>

      <div v-else-if="!events.length" class="workspace-empty">No hay entradas para mostrar.</div>

      <div v-else class="operator-assistance__table-wrap">
        <table class="operator-assistance__table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Nombre</th>
              <th>Apellido</th>
              <th>Localidad</th>
              <th>Asiento</th>
              <th>Código</th>
              <th>Monto</th>
              <th>Estado</th>
              <th>Comentario</th>
              <th>Escaneado por</th>
              <th>Hora</th>
              <th v-if="showStaffPhone">Teléfono</th>
            </tr>
          </thead>

          <tbody>
            <tr
              v-for="(event_t, index) in events"
              :key="event_t.id || index"
              role="button"
              tabindex="0"
              @click="grantAccess(index)"
              @keydown.enter="grantAccess(index)"
              @keydown.space.prevent="grantAccess(index)"
            >
              <td data-label="ID">{{ paymentId(event_t) }}</td>
              <td data-label="Nombre">{{ event_t.first_name || '-' }}</td>
              <td data-label="Apellido">{{ event_t.last_name || '-' }}</td>
              <td data-label="Localidad">{{ event_t.product_name || '-' }}</td>
              <td data-label="Asiento">{{ event_t.seat_name || 'Acceso libre' }}</td>
              <td data-label="Código">{{ event_t.product_code || '-' }}</td>
              <td data-label="Monto">{{ event_t.amount || '-' }}</td>
              <td data-label="Estado">
                <span :class="['workspace-status-pill', accessStateClass(event_t)]">{{ paymentStatusLabel(event_t) }}</span>
              </td>
              <td data-label="Comentario">{{ paymentCommentLabel(event_t) }}</td>
              <td data-label="Escaneado por">{{ event_t.scanned_by_name || 'n/a' }}</td>
              <td data-label="Hora">{{ formatScanDate(event_t.scanned_at) }}</td>
              <td v-if="showStaffPhone" data-label="Teléfono">{{ event_t.phone || '-' }}</td>
              <td class="operator-assistance__tap-hint" data-label="Acción"><i class="fas fa-hand-pointer"></i> Tocar para registrar acceso</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="workspace-actions workspace-actions--end operator-assistance__more">
        <spring-spinner v-if="loading" v-show="next" :size="48" color="#8cf3e8" />
        <button v-show="next && !loading" class="workspace-button" type="button" @click="getEvents(true)">
          <i class="fas fa-plus"></i>
          <span>Cargar más</span>
        </button>
      </div>
    </article>
  </section>
</template>

<script>
import { apiService } from "../../common/api.services.js";
import { SpringSpinner } from 'epic-spinners';
import { formatEventDate } from '@/common/event-timezone.js';

const SCAN_DATE_FORMAT = {
  day: '2-digit',
  month: 'short',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  timeZoneName: 'short',
}


export default {
  name: "AssistanceList",
  data() {
    return {
      events: [],
      next: null,
      loadingTable: true,
      loadingMain: false,
      loadingList: false,
      success: false,

      search: "",
      loading: false,
      is_staff: localStorage.getItem('is_staff')
    };
  },
  components: {
    SpringSpinner,
  },

  props: {
    event: {
      required: true,
    },
  },

  computed: {
    showStaffPhone() {
      return this.is_staff === true || this.is_staff === 'true'
    },

    heading() {
      return [
        {
          name: "name",
          title: "Sección",
        },
        {
          name: "name",
          title: "Entradas Emitidas",
        },
        {
          name: "name",
          title: "Entradas Restantes",
        },
      ];
    },
  },

  created() {
    this.getEvents(false);
  },

  methods: {

    async grantAccess(index){

      if(this.paymentId(this.events[index])!="n/a"){



    

      if(confirm("Desea confirmar el acceso manual de " + this.events[index].first_name + " " + this.events[index].last_name)){

    



      let event_id= this.event.id
      let idt=this.events[index].id   
      this.loadingMain=true

      let endpoint = `/api/update-invoice-item/${event_id}/${idt}/`;
      
      apiService(endpoint).then((data) => {
          if (data && data.message=="Entrada Procesada"){

            let msg= "ÉXITO: Acceso Concedido - " + this.events[index].product_name
          alert (msg)
          this.events[index].scanned_by_name = data.ticket ? data.ticket.scanned_by_name : this.events[index].scanned_by_name
          this.events[index].scanned_at = data.ticket ? data.ticket.scanned_at : this.events[index].scanned_at
          
          this.success=true
          this.loadingMain=false
          this.search=""

          }else{
             alert ("ERROR: La entrada ya fue utilizada o no pertenece al evento.")

            this.err=true
            this.loadingMain=false
            this.search=""
          //ok
          }
         

        })

        }
  


    }else{
      alert("No se puede validar el acceso. Solicite un comprobante del pago y consulte con un administrador")
    }

    },

    populateBar() {
      this.generatedBar = {
        labels: ["Tarjeta", "Transferencia", "Efectivo"],
        datasets: [
          {
            label: "$",
            backgroundColor: "blue",
            data: [this.card, this.bank, this.cash],
          },
        ],
      };
    },

    populateData() {
      let labelArr = [];
      let backgroundColorArr = [];
      let dataArr = [];

      for (let index = 0; index < this.eventTickets.length; index++) {
        let lname =
          this.eventTickets[index].name + "-" + this.eventTickets[index].code;
        labelArr.push(lname);

        let maxVal = 0xffffff; // 16777215
        let randomNumber = Math.random() * maxVal;
        randomNumber = Math.floor(randomNumber);
        randomNumber = randomNumber.toString(16);
        let randColor = randomNumber.padStart(6, 0);
        let color = `#${randColor.toUpperCase()}`;
        backgroundColorArr.push(color);

        let value =
          this.eventTickets[index].initial_quantity -
          this.eventTickets[index].remaining_tickets;
        dataArr.push(value);

        let obj = Object();
        obj.section =
          this.eventTickets[index].name + "-" + this.eventTickets[index].code;
        obj.tickets = value;
        obj.remaining = this.eventTickets[index].remaining_tickets;
        this.total_tickets.push(obj);
      }
      this.loadingTable = false;
      this.generatedData = {
        labels: labelArr,
        datasets: [
          {
            label: "Tickets x Sección",
            backgroundColor: backgroundColorArr,
            data: dataArr,
          },
        ],
      };
    },

    openEvent(_id) {
      this.$router.push({ name: "EventHostView", params: { slug: _id } });
    },

    searchEvents() {
      this.events = [];
      this.next = null;
      this.getEvents(false);
    },

    paymentId(eventTicket) {
      return eventTicket && eventTicket.payment ? eventTicket.payment.id : 'n/a'
    },

    paymentStatusLabel(eventTicket) {
      const status = eventTicket && eventTicket.payment ? Number(eventTicket.payment.status) : null
      if (status === 0) return 'Pendiente'
      if (status === 1) return 'Emitido'
      if (status === 3) return 'En revisión'
      if (status === 4) return 'Rechazado'
      return 'n/a'
    },

    paymentCommentLabel(eventTicket) {
      const comment = eventTicket && eventTicket.payment ? eventTicket.payment.comment : ''
      return comment && comment !== 'fomoaut' ? comment : 'n/a'
    },

    accessStateClass(eventTicket) {
      const status = eventTicket && eventTicket.payment ? Number(eventTicket.payment.status) : null
      if (status === 1) return 'is-active'
      if (status === 3 || status === 0) return 'is-warning'
      return 'is-off'
    },

    getEvents(type) {
      // make a GET Request to the questions list endpoint and populate the questions array

      //tipo 1 para generico y tipo 2 para mis cursos y usar el mismo componente
      let endpoint = "/api/invoice-assistance-items/?event=" + this.event.id;


     

      if (this.next && type) {
        endpoint = this.next;
        this.loading=true
      } else {
        this.loadingList = true
      }

      if (this.search != "" && !type) {
        endpoint =
          "/api/invoice-assistance-items/?search=" +
          this.search +
          "&event=" +
          this.event.id;
          
      }


      this.loadingQuestions = true;
      apiService(endpoint).then((data) => {
        const items = Array.isArray(data) ? data : (data && data.results ? data.results : [])
        this.events = this.events.concat(items);
        this.showLoading = false;
        this.loading=false
        this.loadingList=false
        if (data && data.next) {
          //si no es null
          this.next = data.next;
        } else {
          //Si no es null
          this.next = null;
        }
      }).finally(() => {
        this.loading = false
        this.loadingList = false
      });
    },

    formatScanDate(value) {
      if (!value) {
        return 'n/a'
      }

      return formatEventDate(value, this.event, SCAN_DATE_FORMAT)
    },

  },
};
</script>

<style scoped>
.operator-assistance__header {
  margin-bottom: 0;
}

.operator-assistance__title {
  margin: 8px 0 0;
  color: var(--text-main);
  font-family: 'Syne', 'Sora', sans-serif;
  font-size: clamp(1.5rem, 2.4vw, 2.2rem);
  line-height: 1;
  letter-spacing: -0.04em;
}

.operator-assistance__toolbar {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 12px;
  align-items: center;
  margin-bottom: 18px;
}

.operator-assistance__search {
  width: 100%;
}

.operator-assistance__loading {
  display: grid;
  place-items: center;
  gap: 12px;
  min-height: 240px;
  color: var(--text-soft);
}

.operator-assistance__table-wrap {
  overflow-x: auto;
  border-radius: 22px;
  border: 1px solid rgba(194, 212, 224, 0.1);
  background: rgba(255, 255, 255, 0.03);
}

.operator-assistance__table {
  width: 100%;
  min-width: 980px;
  border-collapse: collapse;
}

.operator-assistance__table th,
.operator-assistance__table td {
  padding: 14px 16px;
  border-bottom: 1px solid rgba(194, 212, 224, 0.08);
  color: rgba(226, 235, 246, 0.88);
  text-align: left;
  vertical-align: top;
}

.operator-assistance__table th {
  color: rgba(202, 214, 223, 0.78);
  font-family: 'Space Grotesk', sans-serif;
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.14em;
  text-transform: uppercase;
}

.operator-assistance__table tbody tr {
  cursor: pointer;
  transition: background 0.2s ease;
}

.operator-assistance__table tbody tr:focus-visible {
  outline: 2px solid rgba(140, 243, 232, 0.72);
  outline-offset: 3px;
}

.operator-assistance__table tbody tr:last-child td {
  border-bottom: 0;
}

.operator-assistance__more {
  margin-top: 18px;
}

.operator-assistance__tap-hint {
  display: none;
}

@media (hover: hover) {
  .operator-assistance__table tbody tr:hover {
    background: rgba(140, 243, 232, 0.07);
  }
}

@media (max-width: 720px) {
  .operator-assistance__toolbar {
    grid-template-columns: 1fr;
  }

  .operator-assistance__table-wrap {
    overflow: visible;
    border: 0;
    background: transparent;
  }

  .operator-assistance__table,
  .operator-assistance__table tbody,
  .operator-assistance__table tr,
  .operator-assistance__table td {
    display: block;
    width: 100%;
  }

  .operator-assistance__table {
    min-width: 0;
    border-collapse: separate;
  }

  .operator-assistance__table thead {
    display: none;
  }

  .operator-assistance__table tbody {
    display: grid;
    gap: 12px;
  }

  .operator-assistance__table tbody tr {
    position: relative;
    display: grid;
    gap: 9px;
    padding: 15px;
    border-radius: 22px;
    border: 1px solid rgba(196, 206, 228, 0.12);
    background:
      radial-gradient(circle at 14% 0%, rgba(208, 218, 236, 0.08), transparent 26%),
      radial-gradient(circle at 84% 14%, rgba(92, 71, 130, 0.14), transparent 22%),
      linear-gradient(180deg, rgba(255, 255, 255, 0.035), rgba(255, 255, 255, 0.008)),
      rgba(7, 8, 13, 0.96);
    box-shadow: 0 18px 36px rgba(0, 0, 0, 0.22);
  }

  .operator-assistance__table td {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 14px;
    padding: 0;
    border-bottom: 0;
    color: rgba(226, 235, 246, 0.9);
    font-size: 0.9rem;
    text-align: right;
  }

  .operator-assistance__table td::before {
    content: attr(data-label);
    flex: 0 0 auto;
    color: rgba(202, 214, 223, 0.68);
    font-family: 'Space Grotesk', sans-serif;
    font-size: 0.66rem;
    font-weight: 800;
    letter-spacing: 0.13em;
    text-align: left;
    text-transform: uppercase;
  }

  .operator-assistance__table td[data-label='Nombre'],
  .operator-assistance__table td[data-label='Apellido'] {
    display: inline;
    color: #f4f7ff;
    font-family: 'Syne', 'Sora', sans-serif;
    font-size: 1.18rem;
    font-weight: 700;
    letter-spacing: -0.04em;
    line-height: 1.1;
    text-align: left;
  }

  .operator-assistance__table td[data-label='Nombre']::before,
  .operator-assistance__table td[data-label='Apellido']::before {
    content: '';
    display: none;
  }

  .operator-assistance__table td[data-label='ID'],
  .operator-assistance__table td[data-label='Monto'],
  .operator-assistance__table td[data-label='Comentario'] {
    display: none;
  }

  .operator-assistance__tap-hint {
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    gap: 8px !important;
    min-height: 40px;
    margin-top: 4px;
    padding: 0 12px !important;
    border-radius: 999px;
    color: #081114 !important;
    background: linear-gradient(135deg, rgba(243, 248, 251, 0.94), rgba(138, 223, 216, 0.9));
    font-family: 'Space Grotesk', sans-serif;
    font-size: 0.78rem !important;
    font-weight: 800;
    letter-spacing: 0.01em;
    text-align: center !important;
  }

  .operator-assistance__tap-hint::before {
    content: '' !important;
    display: none;
  }

  .operator-assistance__toolbar .workspace-button,
  .operator-assistance__more .workspace-button {
    width: 100%;
  }
}
</style>
